import { memo } from "react";
import { useDispatch } from "react-redux";

import { useChartsContext } from "contexts/ChartContext";
import { updateChartByPath } from "store/features";

import { useChartEntities } from "hooks/charts";

import { Icon_LicencedVolume } from "components/icons";

import ToolbarButton from "../../base/ToolbarButton";

const LicensedVolumeLineToggle = () => {
  const dispatch = useDispatch();
  const { id } = useChartsContext();
  const { licensedVolumeLine } = useChartEntities(id);

  const isButtonEnabled = licensedVolumeLine?.enabled;
  const isActive = licensedVolumeLine?.active;
  const isButtonVisible = licensedVolumeLine?.show;

  const toggle = (active: boolean) => {
    dispatch(
      updateChartByPath({
        id,
        path: "features.licensedVolumeLine.active",
        value: active
      })
    );
  };

  if (!isButtonVisible) {
    return null;
  }

  return (
    <ToolbarButton
      active={isActive}
      icon={<Icon_LicencedVolume />}
      overflowLabel="Licensed Volume Line"
      tooltipText="Show Licensed Volume Line"
      onToggle={toggle}
      disabled={!isButtonEnabled}
      data-testid="licensed-volume-line-toggle"
    />
  );
};

export default memo(LicensedVolumeLineToggle);
